import styled from 'styled-components'

const WebsiteTab = styled.div`
  
`

export {WebsiteTab}
